import {
  AppointmentInterface,
  CarDetailInterface,
  JobInterface,
} from '../interfaces/appointments';

export const appointments = [
  {
    id: 1,
    name: 'Hector Mckeown',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [1, 2],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: true,
  },
  {
    id: 2,
    name: 'Carley Howarth',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [2, 4],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 3,
    name: 'Kurt Ingram',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [1],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 4,
    name: 'Ciara Kaur',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [2],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 5,
    name: 'Keelan Mcdonnell',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [2, 3],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 6,
    name: 'Stefanie Whitehouse',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [4],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 7,
    name: 'Eryn Mahoney',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [1],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 8,
    name: 'Alysia Clayton',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [1, 4],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 9,
    name: 'Edna Long',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [3],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
  {
    id: 10,
    name: 'Thea Xiong',
    appointment_date: '2021-08-25T17:52:48.132Z',
    services: [2],
    address: 'London',
    vehicle: 'FR14ERF',
    comment: 'Car does not work correctly',
    history: [],
    hasInsurance: false,
  },
] as AppointmentInterface[];

export const carDetailsMock = [
  {
    id: 1,
    model: 'Nissan',
    number: 'KR15BWN',
  },
] as CarDetailInterface[];

export const jobsMocks = [] as JobInterface[];
